import React, { useState } from 'react';

const initialState = {
  itensf: {
    teste: "zap"
  },
  itens: {
    teste: "zap"
  }
}

const setEstoque = (state, setState, itens, teste) => {
    setState({itens, teste})
  }

export const EstoqueContext = React.createContext({
  state: initialState,
  actions: {
    setEstoque: () => {}
  }
});


export const EstoqueContextProvider = props => {
    const [state, _setState] = useState(initialState)

    const setState = (_state) => {
        const newState = { ...state, ..._state }
        _setState(newState)
    }

    const actions = {
      setEstoque: setEstoque.bind(null, state, setState)
    }

    return (
        <EstoqueContext.Provider value={{ state, actions }} >
            {props.children}
        </EstoqueContext.Provider>
    );
}